<script>
/* global fbq */
import { required, email, helpers } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import axios from 'axios';
import Lottie from "@/components/widgets/lottie.vue";
import animationSuccess from "@/components/widgets/Animation-1701822503345.json";
import animationFailure from "@/components/widgets/Animation-1701855501291_grande.json";
import Footer from "@/components/footer-login";
import Layout from "@/layouts/auth-layout.vue";
import PageHeader from "@/components/page-header";
import SelectOptions from "@/components/settore-options";
// import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";

export default {
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  components: {
    Lottie,
    Footer,
    Layout,
    PageHeader,
    SelectOptions,
    // Multiselect,
  },
  data() {
    return {
      queryEmail: this.$route.query.email || '',
      user: {
        name: "",
        surname: "",
        email: this.$route.query.email || '',
        password: "",
        confirm_password: "",
        termsAccepted: false,
        nomeazienda: "",
        aziendadescrizione: "",
        settoreazienda: "",
        linguaDocumento: "",
      },
      processing: false,
      submitted: false,
      tryingToRegister: false,
      showErrorModal: false,
      errorMessage: "",
      showSuccessModal: false,
      succesOptions: { animationData: animationSuccess },
      failureOptions: { animationData: animationFailure },
      passwordVisible: false,
      selectedAlertEmails: [],
      // selectedAlertTelegram: [],
    };
  },
  validations: {
    user: {
      name: {
        required: helpers.withMessage("Nome richiesto", required),
      },
      surname: {
        required: helpers.withMessage("Cognome richiesto", required),
      },
      email: {
        required: helpers.withMessage("Email richiesta", required),
        email: helpers.withMessage("Inserisci una email valida", email),
      },
      password: {
        required: helpers.withMessage("Password richiesta", required),
      },
      confirm_password: {
        required: helpers.withMessage("Conferma Password richiesta", required),
      },
      termsAccepted: {
        required: helpers.withMessage("Devi accettare i Termini e Condizioni.", required),
      },
      linguaDocumento: {
        required: helpers.withMessage("Lingua per comunicazioni email e notifiche richiesta.", required),
      },
    },
  },
  computed: {
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  methods: {
    getErrorMessage(error) {
      if (error.response && error.response.data) {
        const firstKey = Object.keys(error.response.data)[0];
        if (firstKey && error.response.data[firstKey].length > 0) {
          this.errorMessage = this.$t(error.response.data[firstKey][0]);
        } else {
          this.errorMessage = this.$t('An error occurred during registration.');
        }
      } else {
        this.errorMessage = this.$t('An error occurred during registration.');
      }
    },
    togglePasswordVisibility() {
      this.passwordVisible = !this.passwordVisible;
    },
    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    },
    async tryToRegisterIn() {
      this.processing = true;
      this.submitted = true;
      this.v$.$touch();
      if (!this.v$.$invalid) {
        try {
          // Get the _fbp cookie (Facebook Pixel cookie)
          const _fbp = this.getCookie('_fbp');
          const _fbc = this.getCookie('_fbc'); // Facebook Click ID cookie
          const userAgent = navigator.userAgent;
          console.log('_fbp:', _fbp);
          const formData = {
            email: this.user.email,
            first_name: this.user.name,
            last_name: this.user.surname,
            password: this.user.password,
            password2: this.user.confirm_password,
            accept_terms: this.user.termsAccepted,
            alert_emails: this.selectedAlertEmails.join(','),
            // alert_telegram: this.selectedAlertTelegram.join(','),
            nome_azienda: this.user.nomeazienda,
            descrizione_azienda: this.user.aziendadescrizione,
            settore_azienda: this.user.settoreazienda,
            lingua_documento: this.user.linguaDocumento,
            _fbp: _fbp,
            _fbc: _fbc,
            user_agent: userAgent
          };
          console.log('data alert_emails:', this.selectedAlertEmails.join(','));
          
          axios.post(`${process.env.VUE_APP_BACKEND_URL}/api/register/`, formData)
            .then(response => {
              if (response.status === 201) {
                const eventID = response.data.event_id;  // Get the eventID from the backend
                // Fire the Facebook Pixel event using the same eventID for deduplication
                fbq('track', 'CompleteRegistration', {
                  eventID: eventID  // Use the eventID generated in the backend
                });
                this.showSuccessModal = true;
              }
            })
            .catch(error => {
              console.error('Registration failed', error);
              this.getErrorMessage(error);
              this.showErrorModal = true;
            });
        } catch (error) {
          this.processing = false;
          console.error('Registration failed', error);
          // this.errorMessage = error.response && error.response.data ? error.response.data : 'An error occurred during registration.';
          this.getErrorMessage(error);
          this.showErrorModal = true;
        } finally {
          this.processing = false;
        }
      } else {
        this.processing = false;
      }
    },
    closeSuccessModalAndRedirect() {
      this.showSuccessModal = false;
      this.$router.push('/login'); // Reindirizza l'utente alla pagina di login
    },
  },
  created() {
    const sessionId = this.$route.query.CHECKOUT_SESSION_ID;
    if (sessionId) {
      axios.get(`${process.env.VUE_APP_BACKEND_URL}/api/retrieve-email`, { params: { session_id: sessionId } })
        .then(response => {
          this.user.email = response.data.email;
          this.queryEmail = response.data.email;  // Assuming the backend returns the email
        })
        .catch(error => {
          console.error('Error fetching email:', error);
        });
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader :titoloScheda="$t('t-signin')"/>
    <BRow class="justify-content-center">
      <BCol md="8" lg="6" xl="5">
        <BCard no-body class="mt-4">
          <BCardBody class="p-4">
            <div class="text-center mt-2">
              <h5 class="text-primary">{{ $t('crea-nuovo-account') }}</h5>
              <p class="text-muted">{{ $t('ottieni-il-tuo-account') }} {{ $appConfig.nomeSito }}</p>
            </div>
            <div class="p-2 mt-4">
              <form class="needs-validation" @submit.prevent="tryToRegisterIn">
                <div v-if="notification.message" :class="'alert ' + notification.type">{{ notification.message }}</div>
                <div class="mb-3">
                  <label for="username" class="form-label">{{ $t('nome') }}<span class="text-danger">*</span></label>
                  <input type="text" class="form-control" v-model="user.name" id="username" 
                    :class="{ 'is-invalid': submitted && v$.user.name.$error, }" :placeholder="$t('inserisci-nome')">
                  <div v-if="submitted && v$.user.name.$error" class="invalid-feedback">
                    <span v-if="v$.user.name.required.$message">{{ $t('validation-name-required') }}</span>
                  </div>
                </div>

                <div class="mb-3">
                  <label for="usersurname" class="form-label">{{ $t('cognome') }} <span class="text-danger">*</span></label>
                  <input type="text" class="form-control" v-model="user.surname" id="usersurname"
                     :class="{'is-invalid': submitted && v$.user.surname.$error, }" :placeholder="$t('inserisci-cognome')">
                  <div v-if="submitted && v$.user.surname.$error" class="invalid-feedback">
                    <span v-if="v$.user.surname.required.$message">{{ $t('validation-surname-required') }}</span>
                  </div>
                </div>

                <div class="mb-3">
                  <label for="useremail" class="form-label">Email<span class="text-danger">*</span></label>
                  <input type="email" class="form-control" v-model="user.email" id="useremail" :class="{'is-invalid': submitted && v$.user.email.$error, }"
                    :placeholder="$t('placeholder-inserisci-email')" :readonly="queryEmail.length > 0">
                  <div v-for="(item, index) in v$.user.email.$errors" :key="index" class="invalid-feedback">
                    <span v-if="item.$message">{{ $t('validation-email-required') }}</span>
                  </div>
                </div>

                <div class="mb-2">
                  <label for="userpassword" class="form-label">Password <span class="text-danger">*</span></label>
                  <div class="position-relative auth-pass-inputgroup mb-3">
                    <input :type="passwordVisible ? 'text' : 'password'" class="form-control" v-model="user.password"
                      :class="{'is-invalid': submitted && v$.user.password.$error, }" id="userpassword" :placeholder="$t('placeholder-inserisci-password')">
                    <BButton variant="link" class="position-absolute end-0 top-0 text-decoration-none text-muted" type="button" id="password-addon" @click="togglePasswordVisibility">
                      <i :class="passwordVisible ? 'ri-eye-off-fill' : 'ri-eye-fill'"></i>
                    </BButton>
                    <div v-if="submitted && v$.user.password.$error" class="invalid-feedback">
                      <span v-if="v$.user.password.required.$message">{{ $t('password-required') }}</span>
                    </div>
                  </div>
                </div>

                <div class="mb-2">
                  <label for="userconfirmpassword" class="form-label">{{ $t('conferma-password') }}<span class="text-danger">*</span>
                  </label>
                  <div class="position-relative auth-pass-inputgroup mb-3">
                    <input :type="passwordVisible ? 'text' : 'password'" class="form-control" v-model="user.confirm_password" 
                      :class="{'is-invalid': submitted && v$.user.password.$error,}" id="userconfirmpassword" :placeholder="$t('placeholder-inserisci-password-conferma')">
                    <BButton variant="link" class="position-absolute end-0 top-0 text-decoration-none text-muted" type="button" id="confirm-password-addon" @click="togglePasswordVisibility">
                      <i :class="passwordVisible ? 'ri-eye-off-fill' : 'ri-eye-fill'"></i>
                    </BButton>
                    <div v-if="submitted && v$.user.confirm_password.$error" class="invalid-feedback">
                      <span v-if="v$.user.password.required.$message">{{ $t('conferma-password-required') }}</span>
                    </div>
                  </div>
                </div>
                <div>
                  <label for="linguaDocumento" class="form-label">{{ $t('lingua-documenti-docutrap') }} <span class="text-danger">*</span></label>
                  <p class="form-text mb-2">{{$t('seleziona-la-lingua-che-vuoi-che-venga-usata-nella-generazione-del-documento-docutrap')}}</p>
                  <select class="form-select mb-3" v-model="user.linguaDocumento" name="linguaDocumento" id="linguaDocumento" :class="{ 'is-invalid': submitted && v$.user.linguaDocumento.$error,}">
                    <option value="">{{ $t('scegli-una-lingua') }}</option>
                    <option value="Italiano">{{ $t('italiano') }}</option>
                    <option value="Français">{{ $t('francese') }}</option>
                    <option value="Deutsch">{{ $t('tedesco') }}</option>
                    <option value="English">{{ $t('inglese') }}</option>
                    <option value="Español">{{ $t('spagnolo') }}</option>
                    <option value="Português">{{ $t('portoghese') }}</option>
                  </select>
                  <div v-if="submitted && v$.user.linguaDocumento.$error" class="invalid-feedback">
                    <span v-if="v$.user.linguaDocumento.required.$message">{{v$.user.linguaDocumento.required.$message}}</span>
                  </div>
                </div>

                <div class="accordion" id="default-accordion-example">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingThree">
                      <button class="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" 
                        aria-expanded="false" aria-controls="collapseThree">{{ $t('inserisci-maggiori-dettagli-sulla-tua-azienda-opzionale') }}</button>
                    </h2>
                    <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#default-accordion-example">
<!--                      <div class="mb-3">-->
<!--                        <label for="emailMultiselect" class="form-label">{{ $t('notifiche-per-email') }}</label>-->
<!--                        <Multiselect-->
<!--                            v-model="selectedAlertEmails"-->
<!--                            id="emailMultiselect"-->
<!--                            mode="tags"-->
<!--                            :close-on-select="false"-->
<!--                            :searchable="true"-->
<!--                            :create-option="true"-->
<!--                            :placeholder="$t('digita-indirizzi-email')"/>-->
<!--                      </div>-->
<!--                      <div class="mb-3">-->
<!--                        <label for="telegramMultiselect" class="form-label">{{ $t('notifiche-per-telegram') }}</label>-->
<!--                        <Multiselect-->
<!--                            v-model="selectedAlertTelegram"-->
<!--                            id="telegramMultiselect"-->
<!--                            mode="tags"-->
<!--                            :close-on-select="false"-->
<!--                            :searchable="true"-->
<!--                            :create-option="true"-->
<!--                            :placeholder="$t('digita-username-telegram')"/>-->
<!--                      </div>-->
                      <div class="mb-3">
                        <label for="usernomeazienda" class="form-label">{{ $t('nome-azienda') }}</label>
                        <input type="text" class="form-control" v-model="user.nomeazienda" id="usernomeazienda" :placeholder="$t('inserisci-nome-dellazienda')">
                      </div>
                      <div>
                        <label for="usersettoreazienda" class="form-label">{{$t('settore-di-attivita-dellazienda')}}</label>
                        <p class="form-text mb-2">{{$t('seleziona-il-settore-di-attivita-principale-della-tua-azienda-questo-ci-aiutera-a-personalizzare-i-nostri-servizi-in-base-alle-specifiche-esigenze-del-tuo-settore')}}</p>
                        <select class="form-select mb-3" v-model="user.settoreazienda" name="usersettoreazienda" id="usersettoreazienda">
                          <SelectOptions></SelectOptions>
                        </select>
                      </div>
                      <div class="mb-3">
                        <label for="useraziendadescrizione" class="form-label">{{$t('settore-di-attivita-dell-azienda-dettagli-aggiuntivi')}}</label>
                        <textarea class="form-control" v-model="user.aziendadescrizione" id="useraziendadescrizione" :placeholder="$t('placeholder-inserisci-i-dettagli-aggiuntivi')" rows="2"></textarea>
                      </div>
                    </div>
                  </div>
                </div>
                <br>
                <div class="mb-4">
                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="termsCheckbox" v-model="user.termsAccepted">
                    <label for="termsCheckbox" class="form-check-label">{{ $t('registrandoti-aderisci-alla') }}
                      <a href="/terms-of-service" target="_blank" class="fw-semibold text-primary text-decoration-underline"> {{ $t('condizioniDiUtilizzo') }} (TOS)</a> {{ $t('eLa') }}
                        <a :href="$t('privacy-policy-url')" class="fw-semibold text-primary text-decoration-underline" target="_blank">Privacy Policy</a> {{ $t('di') }} {{ $appConfig.nomeSito }}</label>
                  </div>
                  <div v-if="submitted && !user.termsAccepted" class="text-danger">{{ $t('devi-accettare-i-termini-e-condizioni') }}</div>
                </div>
                <div class="mt-4">
                  <b-button variant="warning" class="w-100" type="submit" :disabled="processing"> {{ processing ? $t('attendere') + "..." : $t('registrati') }}</b-button>
                </div>
              </form>
            </div>
          </BCardBody>
        </BCard>
        <div class="mt-4 text-center">
          <p class="mb-0">{{ $t('hai-gia-un-account') }}
            <router-link to="/login" class="fw-semibold text-primary text-decoration-underline"> Login</router-link>
          </p>
        </div>
      </BCol>
    </BRow>
    <b-modal v-model="showSuccessModal" hide-footer hide-header-close class="v-modal-custom" modal-class="zoomIn" centered no-close-on-backdrop>
      <lottie colors="primary:#121331,secondary:#08a88a" trigger="loop" :options="succesOptions" :height="120" :width="120"/>
      <div class="text-center">
        <div class="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
          <h4>{{ $t('registrazione-con-successo') }}</h4>
          <p class="text-muted mx-4 mb-4">{{ $t('ora-puoi-effettuare-il-login') }}</p>
        </div>
      </div>
      <div class="text-center">
        <b-button variant="warning" @click="closeSuccessModalAndRedirect">Login</b-button>
      </div>
    </b-modal>
    <b-modal v-model="showErrorModal" hide-footer hide-header-close class="v-modal-custom" modal-class="zoomIn" centered no-close-on-backdrop>
      <div class="text-center">
        <lottie :options="failureOptions" :height="120" :width="120"/>
        <div class="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
          <h4>{{ $t('errore') }}</h4>
          <p class="text-muted mx-4 mb-4">{{ errorMessage }}</p>
        </div>
      </div>
      <div class="text-center">
        <b-button variant="warning" @click="showErrorModal = false">{{ $t('chiudi') }}</b-button>
      </div>
    </b-modal>
  </Layout>
  <Footer/>
</template>